module.exports = __webpack_public_path__ + "static/media/logo.d9fdcdd6.png";